import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./GroupPluginItem.module.css";
import Button from "shared/Button";
import NoteIcon from "DreamStream/Shared/NoteIcon";
import GroupNotesModal from "DreamStream/Shared/GroupNotesModal";

/**
 * View component. Displays info about a plugin.
 */
export function GroupPluginItem({ pluginInfo, onRemove }) {
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [editNotesModalOpen, setEditNotesModalOpen] = useState(false);

  const groupNotes = {
    name: "Albus and Minerva McGongail Diamonship",
    id: "9636550",
    notes: "This is where you can view the notes...",
  };

  return (
    <div className={styles.gridContainer}>
      <div className={styles.gridItem}>{pluginInfo.id}</div>
      {/* <div className={styles.gridItem}>{pluginInfo.dsId}</div> */}
      <div className={styles.gridItem}>{pluginInfo.userId}</div>
      <div className={styles.gridItem}>{pluginInfo.groupId}</div>
      <div className={styles.gridItem}>
        {pluginInfo.asAdmin ? "True" : "False"}
      </div>
      <div className={styles.gridItem}>{pluginInfo.status}</div>
      <div className={styles.gridItem}>
        {pluginInfo.date} {pluginInfo.time}
      </div>
      <div className={(styles.gridItem, styles.notesDiv)}>
        <NoteIcon
          onClick={() => {
            setNotesModalOpen(true);
          }}
        />
      </div>

      <Button
        className={styles.button}
        onClick={onRemove}
        size="tiny"
        children="Remove"
      />

      <GroupNotesModal
        isOpen={notesModalOpen}
        groupInfo={groupNotes}
        edit={false}
        onClose={() => setNotesModalOpen(false)}
        onClick={() => setEditNotesModalOpen(true)}
      />

      <GroupNotesModal
        isOpen={editNotesModalOpen}
        groupInfo={groupNotes}
        edit={true}
        onClick={() => setEditNotesModalOpen(false)}
      />
    </div>
  );
}

GroupPluginItem.propTypes = {
  /**
   * Object with the plugins info.
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    dsId: PropTypes.string,
    userId: PropTypes.string,
    groupId: PropTypes.string,
    asAdmin: PropTypes.bool,
    status: PropTypes.number,
    date: PropTypes.string,
    time: PropTypes.string,
    details: PropTypes.string,
  }),

  /**
   * 	Function called when remove button is clicked
   */
  onRemove: PropTypes.func,
};
